<script setup lang="ts">
import { ActionButton } from '@taler/ui'
import { compareLocalDate, formatLocalDate, parseLocalDate, plusMonthsKeepingMonthEnd } from '@taler/domain'
import { useI18n } from 'vue-i18n'

/** Moves an ISO date by whole months, never past `max` (today, for every report's end date). */
const props = defineProps<{ modelValue: string; max: string }>()
const emit = defineEmits<{ 'update:modelValue': [value: string] }>()
const { t } = useI18n()

function step(months: number): void {
  const next = formatLocalDate(plusMonthsKeepingMonthEnd(parseLocalDate(props.modelValue), months))
  emit(
    'update:modelValue',
    compareLocalDate(parseLocalDate(next), parseLocalDate(props.max)) > 0 ? props.max : next,
  )
}
</script>

<template>
  <div class="flex items-center gap-1">
    <ActionButton variant="secondary" :aria-label="t('reporting.stepEarlier')" @click="step(-1)">
      <span aria-hidden="true">‹</span>
    </ActionButton>
    <ActionButton variant="secondary" :aria-label="t('reporting.stepLater')" @click="step(1)">
      <span aria-hidden="true">›</span>
    </ActionButton>
  </div>
</template>
